import Form from '../form';
const form = new Form;

export const getCarModels = async () => await form.get('/car/models');